module.exports = __webpack_public_path__ + "625eba6d9b2656012e98e25cf4b68ca2.pdf";